/*
 * @Descripttion: 去重
 * @Author: xutingting
 * @LastEditors: yang chenglin
 */
import React, { useState, useEffect, useContext  } from 'react';
import { Input, Form, Radio, Button, Balloon } from '@alifd/next';
import styles from '../../../index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import nodes from '../../index';
import UUID from '@/utils/UUID';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import { ActivityContext, PageType } from '../../../../Edit';

export default ({ allNodeData = [], prevNodes = [], nextNodes = [], initData = {}, runState = {}, currentNode = {}, changeData = (data) => { }, onCancel = () => { }, validate = () => { }, getAllNodeIds = [] }) => {
    const {
        graph,
        nodeData,
    } = useContext(ActivityContext);

    // 组件内部的数据
    const [data, setData] = useState({
        type: 0, // 新增字段，为了给复制任务时赋上默认值，在初始化时加一个默认值
        ...initData
    })

    /**
     * 改变人群优先级数组
     */
    const changeCrowdPosition = (index1, index2) => {
        let bufferArr = [...data.crowdNames];
        bufferArr[index1] = bufferArr.splice(index2, 1, bufferArr[index1])[0];
        onChange({ crowdNames: bufferArr })
    }
    /**
     * 人群优先级下调
     */
    const crowdPositionDown = (index1, length) => {
        if (index1 + 1 != length) {
            changeCrowdPosition(index1, index1 + 1);
        } else {
            changeCrowdPosition(index1, 0); // 如果已经是最后一位，就换到数组第一位
        }
    }
    /**
     * 人群优先级上调
     */
    const crowdPositionUp = (index1, length) => {
        if (index1 != 0) {
            changeCrowdPosition(index1, index1 - 1);
        } else {
            changeCrowdPosition(index1, length - 1); // 如果已经是第一位，就换到最后一位
        }
    }

    /**
     * 合并新旧状态
     */
    const onChange = (newData) => {
        setData({
            ...data,
            ...newData,
        })
    }

    /**
     * 点击确认
     */
    const confirm = async () => {
        try {
            await Promise.all(Object.keys(validate).map(async validator => {
                // 最终校验数据是否填写完整，然后提交给全局
                try {
                    if (validator in data) {
                        if (validator === 'name') {
                            await validate[validator](data[validator], allNodeData, currentNode, getAllNodeIds);
                        } else {
                            await validate[validator](data[validator]);
                        }
                    }
                } catch (e) {
                    throw new Error(e);
                }
            }));
            changeData(data);
            // 因去重节点后只能跟人群抽取节点，因此做个优化：点击去重节点弹窗的确认按钮后，直接根据去重的信息和顺序，生成1到多个后置人群抽取节点，并连线
            // 循环去重节点内的人群信息数组，查询当前去重节点的所有后置节点，和去重节点内的人群信息数组比对，将去重节点内有的但后置节点中没有的生成人群抽取节点
            const allCrowdNames = data.crowdNames; // 去重节点内的人群信息数组(所有)
            const nextCrowdNames = nextNodes.map(item => ( // 当前节点的所有后置节点
                item.data.extractType
            ));
            allCrowdNames.forEach((item, index) => {
                if (!nextCrowdNames.includes(item)) {
                    dragStart(nodes.sourceNodes[2], item, index);
                }
            })
            onCancel();
        } catch (e) {
            LzMsg.error(e.message);
        }
    };

    /**
     * 拖拽开始(模拟调用拖拽方法，并没有真正拖拽节点，这里是根据去重生成出来的人群抽取节点)
     * @param node 被拖拽的节点
     */
    const dragStart = (node, item, index) => {
        dragStop(event, node, item, index);
    };

    /**
     * 拖拽结束事件(模拟调用拖拽方法，并没有真正拖拽节点，这里是根据去重生成出来的人群抽取节点)
     */
    const dragStop = (event, node, item, index) => {
        // 移除document上的事件绑定
        document.onmousemove = null;
        document.onmouseup = null;
        document.onmouseleave = null;
        const nodeId = UUID.getUUID32();
        // 在节点数据中添加节点信息，
        nodeData.push({
            nodeId,
            ...node.create(),
        });
        const batchNodeX = graph.getNodeById(currentNode.nodeId)?._cfg?.model?.x;
        const batchNodeY = graph.getNodeById(currentNode.nodeId)?._cfg?.model?.y;
        const point = graph.getClientByPoint(batchNodeX, batchNodeY); // 将渲染坐标转换为屏幕/页面坐标
        graph.addNode(nodeId, node, point.x + 200 * (Math.ceil((index + 1) / 5)), point.y + 100 * ((index) % 5));
        try {
            // 赋值节点信息
            const createNode = nodeData.filter((node) => node.nodeId === nodeId)[0];
            createNode.data.name = `人群抽取-${item.length >= 24 ? item.slice(0, 19) : item}`;
            createNode.data.extractType = item;
            // 给节点名称赋值
            graph.updateItem(nodeId, {
                label: createNode.data.name,
                targetCrowd: createNode.data.extractType
            });
            // 连接当前去重节点和新生成的人群抽取节点
            graph.addEdge(
                UUID.getUUID32(),
                currentNode.nodeId,
                createNode.nodeId,
                // `优先${index+1}`
            );
        } catch (e) {
            console.log(e);
        }
    };

    /**
     * 点击退出
     */
    const cancel = () => {
        onCancel()
    }

    const handleData = () => {
        // 过滤前置节点，组成最后的list
      prevNodes.forEach((item, index) => {
        // 如果前置节点不是抽取节点并且填写的人群优先级组里没有这个节点的name，或者前置节点是抽取节点并且人群优先级组里没有抽取节点所抽出来的包名（或者短信节点的短信发送状态类型）
        // 这个是判断目前的前置节点信息和我之前填写时是否一致，如果不一致要修改，如果一致就可以直接读取
        if((item.info.name !== 'CROWD_EXTRACT') || (item.info.name === 'CROWD_EXTRACT' && initData.crowdNames.indexOf(item.data.extractType) === -1)) {
          const bufCrowdList = prevNodes.map((item) => {
            if (item.info.name === 'CROWD_EXTRACT') { // 前置节点是抽取节点，必须是抽取出来的那个人群包
              return item.data.extractType
            } else {
              const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;
              return realCheckName
            }
          })
          onChange({ crowdNames: bufCrowdList })
        }
      })
    }

  /**
   * 打开弹窗判断是未填写内容还是已经填写完重新打开 未填写需判断是否有前置节点，获取上级节点赋值给人群优先级列表，已填写就拿源数据直接初始化
   */
  useEffect(() => {
    if (initData.crowdNames.length === prevNodes.length && prevNodes.length > 0) {
        // 过滤前置节点，判断是否所有前置节点都在init数据内，如果有的不在，就证明是改过的节点，需要重新生成
        const list = prevNodes.map((item, index) => {

            // 人群选择节点，存的是crowdName，人群抽取，则是extractType，其他的普通运算，是name，所以为了判断是不是源数据没变过，需要通过类型判断
            const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : ['CROWD_EXTRACT'].indexOf(item.info.name) > -1 ? item.data.extractType : item.data.name;
            return initData.crowdNames.indexOf(realCheckName);
        });
        let result = list.filter(item => item === -1);
        if (result.length) {
            handleData();
        } else {
            onChange({ crowdNames: initData.crowdNames });
        }
    } else if (initData.crowdNames.length && prevNodes.length > 0) { // 已经填写完，重新打开弹窗
        handleData();
    } else { // 初次打开，直接拼出人群优先级组
      const bufCrowdList = prevNodes.map((item) => {
        if (item.info.name === 'CROWD_EXTRACT') { // 前置节点是抽取节点，必须是抽取出来的那个人群包
          return item.data.extractType
        } else {
            const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;
            return realCheckName
        }
      })
      onChange({ crowdNames: bufCrowdList })
    }
  }, [])

  const formItemLayout = {
    labelCol: {
      span: 5
    },
  };
  // 拖拽组件
  const SortableList = SortableContainer(({ items }) => {
      return (
          <ul className={styles.checkedItemUl}>
              {items.map((item, index) => (
                  <SortableItem key={item.type} index={index} ind={index} item={item} arr={items} />
              ))}
          </ul>
      );
  });

  // 已选项/被拖拽项
  const SortableItem = SortableElement(({ ind, item, arr }) => (
      // zIndex防止拖动时，拖动的目标消失
      // <li
      //     className={`${styles.checkedItem} ${item?.clicked ? styles['checkedBlueWrapper'] : ''}`}
      //     key={ind}
      //     style={{ zIndex: 99999999 }}
      //     onClick={() => { clickCheckedItem(ind + 1, item) }}>
      //     {item.type === 'content' && <span className={styles.mustFill}>*</span>}
      //     {item.name}
      // </li>
      //
      <div key={`${ind}`} className={`${styles.displayFlex} ${styles['remove-crowd-priority']}`}
      style={{ zIndex: 99999999,
      width:320,
      height: 30,
      lineHeight: '30px',
      backgroundColor: '#f5f7f9',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 20px 0 10px'
      }}>
              <div title={item} className={styles['wd-nowrap']}>{item}</div>
              <div className={styles.arrow}>
                {
                  ind < 1 && <img src="//img10.360buyimg.com/imgzone/jfs/t1/133972/24/8032/172/5f448adbE83e9f639/3f95dc8ee16683c8.png" alt="" className={styles.noCursor}/>
                }
                {
                  ind >= 1 && <img src="//img10.360buyimg.com/imgzone/jfs/t1/128596/2/10571/175/5f448adbE510e94e2/df4e27362e63c5b3.png" alt="" onClick={() => crowdPositionUp(ind,arr.length)}/>
                }
                {
                  ind == (arr.length - 1) && <img src="//img10.360buyimg.com/imgzone/jfs/t1/131315/25/8193/172/5f448adbEb301bf29/2148dcce2fe40483.png" alt="" className={styles.noCursor}/>
                }
                {
                  ind != (arr.length - 1) && <img src="//img10.360buyimg.com/imgzone/jfs/t1/118944/8/15990/173/5f448adbE8b4e0114/e9c950e296593ad9.png" alt="" onClick={() => crowdPositionDown(ind,arr.length)}/>
                }
              </div>
            </div>
  ));
  const checkedTemplateItemsDispatch = (value) => {
    onChange({ crowdNames: value.value })
  };
   // 拖拽结束后的数据处理
   function onDepSortEnd({ oldIndex, newIndex }) {
    // 拖拽后重新设置操作区域高度
    // setClickCheckedItemObj({ ...clickCheckedItemObj, top: getArrowPos(newIndex + 1), index: newIndex + 1 });
    // 拖拽后位置重排更新数据: index + 1 因为第一条是固定标题,操作的是除第一条以外的已选数组
    checkedTemplateItemsDispatch({ value: [...arrayMoveImmutable(data.crowdNames, oldIndex, newIndex)] });
  };
  return (
    <div>
      <div style={{display: prevNodes.length >= 2 ? "none" : "block"}} className={styles['warning-text']}>{prevNodes.length ===1 ? '上级节点至少连接2个' : '请先连接上级节点'}</div>
      <Form className={`${styles.formDiv} ${styles.duplicateRemoveDiv} canvasDialog`} {...formItemLayout}>
        <Form.Item label="节点名称:" required requiredMessage="请输入节点名称" style={{padding: '30px 30px 0 30px'}}>
          <Input className={`formItemWidth`} name="removeName" placeholder="请输入节点名称" trim size="small" value={data.name} onChange={(name) => onChange({ name })} showLimitHint maxLength={24}/>
        </Form.Item>
        {/* 原型地址：https://lanhuapp.com/link/#/invite?sid=qX0hqntk */}
        <Form.Item label="去重方式:" required requiredMessage="请选择去重方式" style={{padding: '0 30px'}}>
          <Radio.Group value={data.type} onChange={(type) => onChange({ type })}>
            <Radio value={0}>
                连线顺序去重
                <Balloon.Tooltip
                    trigger={
                        <span className={`iconfont icon-icon4-33 ${styles['tooltip-icon-left']}`} />
                    }
                    align="t"
                    >
                    <div className={styles['tooltip-desc-wd']}>
                    根据当前人群节点的位置顺序进行去重运算，支持手动调整去重顺序
                    </div>
                </Balloon.Tooltip>
            </Radio>
            <Radio value={1}>
                升序去重
                <Balloon.Tooltip
                    trigger={
                        <span className={`iconfont icon-icon4-33 ${styles['tooltip-icon-left']}`} />
                    }
                    align="t"
                    >
                    <div className={styles['tooltip-desc-wd']}>
                    根据预执行后的人群数量<span style={{color: '#FF3333'}}>从小到大</span>进行去重运算，<span style={{color: '#1677FF'}}>此方式必须先进行预执行后提交操作</span>，且不支持手动调整去重顺序
                    </div>
                </Balloon.Tooltip>
            </Radio>
            <Radio value={2}>
                降序去重
                <Balloon.Tooltip
                    trigger={
                        <span className={`iconfont icon-icon4-33 ${styles['tooltip-icon-left']}`} />
                    }
                    align="t"
                    >
                    <div className={styles['tooltip-desc-wd']}>
                    根据预执行后的人群数量<span style={{color: '#FF3333'}}>从大到小</span>进行去重运算，<span style={{color: '#1677FF'}}>此方式必须先进行预执行后提交操作</span>，且不支持手动调整去重顺序
                    </div>
                </Balloon.Tooltip>
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="人群优先级:" required style={{padding: '0 30px'}}>
            {
              data.type === 0 ?
              <div className="formItemWidth" style={{overflowY: 'auto',overflowX: 'hidden',maxHeight: '300px'}}>
                <SortableList
                    helperClass="row-dragging-item" // 可以添加一些样式，当然也可以直接设置里面的标签
                    distance={5} // 拖动了一定数量的像素后才排序，主要防止其上的点击事件和拖动事件同时触发
                    axis="y" // 项目可以水平、垂直或在网格中排序。 取值范围:x、y或xy
                    items={data.crowdNames} // 数组类型的数据
                    onSortEnd={onDepSortEnd}
                />
                {/* {
                    data.crowdNames.map((i, index, arr) => <div key={`${i}`} className={`${styles.displayFlex} ${styles['remove-crowd-priority']}`}>
                    <div title={i} className={styles['wd-nowrap']}>{i}</div>
                    <div className={styles.arrow}>
                        {
                        index < 1 && <img src="//img10.360buyimg.com/imgzone/jfs/t1/133972/24/8032/172/5f448adbE83e9f639/3f95dc8ee16683c8.png" alt="" className={styles.noCursor}/>
                        }
                        {
                        index >= 1 && <img src="//img10.360buyimg.com/imgzone/jfs/t1/128596/2/10571/175/5f448adbE510e94e2/df4e27362e63c5b3.png" alt="" onClick={() => crowdPositionUp(index,arr.length)}/>
                        }
                        {
                        index == (arr.length - 1) && <img src="//img10.360buyimg.com/imgzone/jfs/t1/131315/25/8193/172/5f448adbEb301bf29/2148dcce2fe40483.png" alt="" className={styles.noCursor}/>
                        }
                        {
                        index != (arr.length - 1) && <img src="//img10.360buyimg.com/imgzone/jfs/t1/118944/8/15990/173/5f448adbE8b4e0114/e9c950e296593ad9.png" alt="" onClick={() => crowdPositionDown(index,arr.length)}/>
                        }
                    </div>
                    </div> )
                }*/}
                <div className={styles.removeNote}>
                    注：如同一客户出现在多个人群内，将被保留在优先级最高的人群中，优先级低的人群将删除该客户
                </div>
              </div> :
              <div style={{lineHeight: '28px'}}>画布 预执行 / 提交 后，方可来此查看人群优先级排序</div>
            }
        </Form.Item>
        <Form.Item label="备注:" style={{padding: '0 30px'}}>
          <Input.TextArea className={`formItemWidth`} name="remark" placeholder="请输入备注" size="small" trim value={data.remark} onChange={(remark) =>  onChange({ remark })} showLimitHint maxLength={150}/>
        </Form.Item>
        <hr />
        <div style={{padding: '15px 30px 0 0', height:'60px'}}>
        <Button type="primary" className={`submit-btn ${styles.w88}`} onClick={confirm} style={{float:'right'}}>确认</Button>
          <Button type="normal" className={`cancel-btn ${styles.mr10} ${styles.w88}`} onClick={cancel} style={{float:'right'}}>取消</Button>
        </div>
      </Form>
    </div>
  )
}
